var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import { Inset } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import { generateUUID } from "syf-js-utilities";
import { ConfirmChangeButtons, EnrollmentChangeWrapper, WhiteSpaceBody, } from "./subcomponents";
import { useAccountFeatures } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import getConsentLinks from "../../../helpers/getConsentLinks";
import getEnrollmentDetails from "../../../helpers/getEnrollmentDetails";
import getPaperFeeApplicable from "../../../helpers/getPaperFeeApplicable";
import getPaperFeeMessage from "../../../helpers/getPaperFeeMessage";
import ToggleShowEnrollmentErrorHook from "../../../helpers/toggleShowEnrollmentError";
import StatementsTrans from "../../atoms/StatementsTrans";
import theme from "../../theme";
import { ConsentLink } from "../EnrollCard/subcomponents";
import ResponsiveButton from "../subcomponents";
import { getClickAnalyticsProperties } from "../../../const/analytics";
var EnrollmentChangeCard = function (_a) {
    var onEnroll = _a.onEnroll, onClose = _a.onClose, enrollmentType = _a.enrollmentType, availableEnrollmentType = _a.availableEnrollmentType;
    var _b = useStatementsContext(), dispatch = _b.dispatch, _c = _b.state, isMutationLoading = _c.isMutationLoading, accountId = _c.accountId;
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    var _e = useAccountFeatures(accountId), accountFeatures = _e.data, isAccountFeaturesError = _e.isError, isAccountFeaturesLoading = _e.isLoading;
    var selectedLanguage = i18n.language;
    var shouldShowPaperFee = getPaperFeeApplicable(accountFeatures);
    var paperFeeLetter = getPaperFeeMessage({
        applicableFee: shouldShowPaperFee,
        currentEnrollment: enrollmentType,
        enrollmentOption: availableEnrollmentType,
    });
    var enrollmentDetails = getEnrollmentDetails(availableEnrollmentType, paperFeeLetter);
    var isAddingPaperToPaperless = enrollmentType === "ELECTRONIC" &&
        availableEnrollmentType === "ELECTRONIC_AND_PAPER";
    var handleEnrollmentChange = function (buttonSide) {
        if (isAddingPaperToPaperless && buttonSide === "left") {
            onEnroll(enrollmentDetails.enrollment);
            return;
        }
        if (!isAddingPaperToPaperless && buttonSide === "right") {
            onEnroll(enrollmentDetails.enrollment);
            return;
        }
        onClose();
    };
    ToggleShowEnrollmentErrorHook(isAccountFeaturesLoading, shouldShowPaperFee, isAccountFeaturesError, dispatch);
    return (_jsxs(EnrollmentChangeWrapper, { children: [_jsx(Body, __assign({ weight: "bold" }, { children: t(enrollmentDetails.title) })), _jsx(Inset, { debug: true, top: "medium" }), _jsx(WhiteSpaceBody, { children: [enrollmentDetails.text].map(function (detail) {
                    if (detail === "")
                        return null;
                    return (_jsx(StatementsTrans, { i18nKey: detail, components: {
                            strong: _jsx("strong", {}),
                            consentLink: (_jsx(ConsentLink, { weight: "bold", href: getConsentLinks(selectedLanguage), target: "_blank", color: theme.cyanBlue })),
                        } }, generateUUID()));
                }) }), _jsx(Inset, { debug: true, top: "large" }), _jsx(ConfirmChangeButtons, { children: [enrollmentDetails.leftButton, enrollmentDetails.rightButton].map(function (btnDetail, index) {
                    return (_jsxs(React.Fragment, { children: [_jsx(ResponsiveButton, __assign({ buttonType: btnDetail.buttonType, onClick: function () { return handleEnrollmentChange(btnDetail.name); }, disabled: isMutationLoading }, getClickAnalyticsProperties({
                                reason: btnDetail.analytics,
                            }), { children: t(btnDetail.label) })), index === 0 && _jsx(Inset, { all: "small" })] }, generateUUID()));
                }) })] }));
};
export default EnrollmentChangeCard;
